import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

interface Provider {
    description: string
    id: number
    name: string
    resource_uri: string
}

interface ProductType {
    description: string
    id: number
    name: string
    resource_uri: string
}

interface Product {
    by_dealer: boolean
    dealer_cost: string
    default_price: string
    description: string
    id: number
    is_owned: boolean
    name: string
    provider: Provider
    resource_uri: string
    type: null | ProductType
    vehicle_condition: null | string
}

interface WarrantyProductPrice {
    cc_max: null | number
    cc_min: null | number
    dealer_cost: null | string
    factory_warranty_length: null | number
    has_aftermarket_wheels: null | boolean
    id: number
    is_new: null | boolean
    model: null | string
    newest_year: null | number
    oem: null | string
    oldest_year: null | number
    price: string
    product: Product
    resource_uri: string
    term: null | number
    under_factory_warranty: null | boolean
}

export interface WarrantyApplication {
    id?: number
    application: string
    customer_price: null | string
    customer_price_is_editable: boolean
    warranty_product_price: WarrantyProductPrice
}

export interface ResponseWarrantyProductPrices {
    objects: WarrantyApplication[]
}

export default async function getWarrantyProductPrices(
    applicationId: number,
    abortController: AbortController,
) {
    try {
        if (!applicationId) {
            throw new Error('invalid UUID')
        }

        const { data }: { data: ResponseWarrantyProductPrices } =
            await axios.get(
                // eslint-disable-next-line max-len
                `${config.API_BASE_URL}/api/v1/application_warranty_product_prices/prices-for-vehicle/?application_id=${applicationId}`,
                {
                    signal: abortController.signal,
                    withCredentials: true,
                },
            )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get warranty product prices: ${axiosError.message}`,
            axiosError,
            { applicationId },
        )

        throw new Error(axiosError.message)
    }
}
